<template>
	<div>
		<div>
			<div style="margin-top: 15px;">
				<el-row :gutter="12">
					<el-col :span="8">
						<el-card shadow="hover" style="border-top:3px solid #0099FB;">
							<div slot="header">
			    				<span>余额</span>
							</div>
							<div class="text item">
								<div style="font-size: 24px;">
								  	<span>{{moneyFormat(money)}}元</span>
								</div>
								<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
								    <span>钱包</span>
								</div>
							</div>
						</el-card>
					</el-col>
					<el-col :span="8" v-if="role == 2 || role == 3 || role==8 || role==9">
						<el-card shadow="hover" style="border-top:3px solid #52C41A;">
							<div slot="header">
			    				<span>押金</span>
							</div>
							<div class="text item">
								<div style="font-size: 24px;">
								  	<span>{{moneyFormat(freeze)}}元</span>
								</div>
								<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
								    <span>钱包</span>
								</div>
							</div>
						</el-card>
					</el-col>
					<el-col :span="8">
						<el-card shadow="hover" style="border-top:3px solid #F5222D;" v-if="isAgent">
							<div slot="header">
			    				<span>销量</span>
							</div>
							<div class="text item">
								<div style="font-size: 24px;">
								  	<span>{{moneyFormat(saleslog)}}元</span>
								</div>
								<div style="color: #C8C9CC;margin-top: 5px;font-size: 12px;">
								    <span>钱包</span>
								</div>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</div>
		</div>
		<div style="margin-top: 15px;">
			<div>
				<el-row :gutter="12">
					<el-col :span="4">
						<el-select v-model="type" style="width: 110px;" @change="updateTable">
							<el-option value="0" label="全部类型"></el-option>
							<el-option value="4" label="租赁商品"></el-option>
							<el-option value="5" label="买断商品"></el-option>
                            <el-option value="6" label="共享商品"></el-option>
						</el-select>
					</el-col>
					<el-col :span="20" style="text-align:right;">
						<el-select style="width: 110px;" v-model="selectValue" placeholder="全部类型">
							<el-option label="订单号" value="1"></el-option>
							<el-option label="订单时间" value="2"></el-option>
						</el-select>
						<el-input type="text" style="width: 235px;margin-left: 3px;" v-model="queryValue" placeholder="请输入" v-if="isInput"></el-input>
						<el-date-picker
								style="width: 235px;margin-left: 3px;"
								v-model="time"
								v-if="!isInput"
								type="daterange"
								range-separator="至"
								start-placeholder="开始日期"
								end-placeholder="结束日期"
								format="yyyy-MM-dd">
						</el-date-picker>
						<el-button type="primary" style="margin-left: 3px;" icon="el-icon-search" @click="updateTable">搜索</el-button>
					</el-col>
				</el-row>
			</div>
			<div style="margin-top: 8px;padding-bottom: 50px;">
				<el-table ref="multipleTable"
						 :data="tableData"
						 style="width: 100%"
						 element-loading-text="数据正在加载中"
						 @selection-change="handleSelectionChange"
						 :header-cell-style="headClass"
						  :row-style="rowClass">
				    <el-table-column type="selection" width="60"></el-table-column>
				    <el-table-column prop="productName" label="订单商品名" sortable></el-table-column>
				    <el-table-column label="类型">
				      	<template  slot-scope="scope">
									<span v-if="scope.row.type == 4">租赁商品</span>
									<span v-if="scope.row.type == 5">买断商品</span>
                                    <span v-if="scope.row.type == 6">共享商品</span>
				      	</template>
				    </el-table-column>
				    <el-table-column prop="nickName" label="付款人"></el-table-column>
				   <!-- <el-table-column label="付款人类型">
				    	<template slot-scope="scope">
				      		<div>
				      			<span v-if="scope.row.roleType == 1">客户</span>
				      			<span v-if="scope.row.roleType == 2">二级代理商</span>
				      			<span v-if="scope.row.roleType == 3">一级代理商</span>
								<span v-if="scope.row.roleType == 8">三级代理商</span>
                                <span v-if="scope.row.roleType == 9">运营商</span>
                                <span v-if="scope.row.roleType == 10">推广人员</span>
				      			<span v-if="scope.row.roleType == 4">品牌商</span>
				      		</div>
				      	</template>
				    </el-table-column>-->
				    <el-table-column label="付款额">
                        <template slot-scope="scope">
				      		<div>
                                <span>{{moneyFormat(scope.row.amount)}}</span>
				      		</div>
				      	</template>
                    </el-table-column>
				    <el-table-column label="厂家收益">
				      	<template slot-scope="scope">
				      		<div>
				      			<div v-if="scope.row.s0 > 0">
				      				<span>{{moneyFormat(scope.row.s0)}}</span>
				      			</div>
				      			<div v-else>
				      				<span>-</span>
				      			</div>
				      		</div>
				      	</template>
				    </el-table-column>
				    <el-table-column v-if="isBrand || role == '3'" :label="$store.getters.customDisplays.profitCenter_income1">
				      	<template slot-scope="scope">
				      		<div>
				      			<div v-if="scope.row.s1 > 0">
				      				<span>{{moneyFormat(scope.row.s1)}}</span>
				      			</div>
				      			<div v-else>
				      				<span>-</span>
				      			</div>
				      		</div>
				      	</template>
				    </el-table-column>
				    <el-table-column v-if="isBrand || role == '2'" :label="$store.getters.customDisplays.profitCenter_income2">
				      	<template slot-scope="scope">
				      		<div>
				      			<div v-if="scope.row.s2 > 0">
				      				<span>{{moneyFormat(scope.row.s2)}}</span>
				      			</div>
				      			<div v-else>
				      				<span>-</span>
				      			</div>
				      		</div>
				      	</template>
				    </el-table-column>
                    <el-table-column v-if="isBrand || role == '8'" :label="$store.getters.customDisplays.profitCenter_income3">
				      	<template slot-scope="scope">
				      		<div>
				      			<div v-if="scope.row.s3 > 0">
				      				<span>{{moneyFormat(scope.row.s3)}}</span>
				      			</div>
				      			<div v-else>
				      				<span>-</span>
				      			</div>
				      		</div>
				      	</template>
				    </el-table-column>
				    <el-table-column prop="finish" label="完成时间" :formatter="dateFormat"></el-table-column>
				    <el-table-column prop="orderId" label="订单号"></el-table-column>
				    <el-table-column label="操作">
				      	<template slot-scope="scope">
				      		<button @click="getMessage(scope.row)">查看</button>
				      	</template>
				    </el-table-column>
				</el-table>
				<el-pagination background
				    	style="text-align:right;margin-top: 15px;"
				        @size-change="handleSizeChange"
				        @current-change="handleCurrentChange"
				        :current-page="currentPage"
				        :page-sizes="[10, 50, 100, 200]"
				        :page-size="pageSize"
				        layout="total, sizes, prev, pager, next, jumper"
				        :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
import axios from 'axios'

export default {
  name: 'profitCenter',
  components: {
  },
  data() {
    return {
    	freeze:0.0,
    	money:0.0,
    	saleslog:0.0,
    	total: 0,
        isAgent:false,
        isBrand: false,
        role:'',
      	currentPage: 1,
　　  	pageSize: 10,
		multipleSelection: [],
		tableData:[],
		type:"0",
		queryValue:'',
		selectValue:'',
		time:[]
    }
  },
  watch: {
  },
  computed:{
  	isInput:function(){
  		if(this.selectValue != "2"){
  			this.queryValue = "";
  			return true;
  		}else{
  			return false;
  		}
  	}
  },
  mounted() {
  	var thiz = this;
  	axios.get(this.$store.getters.getApiValue+'/srsUser/getMyData.do').then(function (response) {
			var data = response.data;
			if(data.status == "200"){
                thiz.role = data.data.role;
				if(data.data.role == "3" || data.data.role == "2" || data.data.role == "8"|| data.data.role == "9"){
					thiz.isAgent = true;
				}
				if (data.data.role == '4' || data.data.role == '7'){
				  thiz.isBrand = true;
        }
			    thiz.initPage();
			    thiz.updateTable();
			}else{
			    thiz.$message.error(data.message);
			}
		}).catch(function (error) {
			console.log(error);
			thiz.$message.error("系统异常,请与管理员联系!");
		});

  	//console.log(this.$store.getters.customDisplays, "~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~")
  },
  beforeDestroy() {
  },
  methods: {
  	initPage(){
  		var thiz = this;
  		axios.get(this.$store.getters.getApiValue+'/order/getWallet.do')
    		.then(function (response) {
			    var data = response.data;
			    if(data.status == "200"){
			    	thiz.money = data.data.wallet.money - data.data.wallet.freeze;
			    	thiz.freeze = data.data.wallet.freeze;
			    	if(thiz.isAgent){
			    		thiz.saleslog = data.data.saleslog;
			    	}
			    }
			}).catch(function (error) {
			    console.log(error);
			});
  	},
  	handleSelectionChange(val) {
      this.multipleSelection = val;
    },
  	handleSizeChange(val) {
      this.pageSize = val;
      this.updateTable();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.updateTable();
    },
    headClass({ row, rowIndex}) {
    	if(rowIndex == 0){
    		return ''
    	}
	    return ''
	},
    rowClass({ row, rowIndex}) {
	    if(rowIndex%2 == 0){
	    	return 'background:#F1F2F7;'
	    }else{
	    	return 'background:white;'
	    }
	    return ''
	},
	updateTable(){
		var thiz = this;
    	var param = {
  				pageId:this.currentPage,
  				size:this.pageSize,
  				type:this.type
  			}
  		if(this.selectValue == "1" && this.queryValue != ""){
  			param.orderId = this.queryValue;
  		}else if(this.selectValue == "2"){
  			if(this.time != null && this.time.length > 0){
	  			param.startDate = this.getStandardDate(this.time[0]);
	  			param.endDate = this.getStandardDate(this.time[1]);
	  		}
  		}
  		const loading = this.$loading({
          lock: true,
          text: '获取表格数据中...',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
        setTimeout(() => {
          loading.close();
        }, 3000);
    	axios.get(this.$store.getters.getApiValue+'/income/searche.do',{
  			params:param
  		}).then(function (response) {
  			loading.close();
		    var data = response.data;
		    if(data.status == "200"){
		    	thiz.total = data.totalCount;
		    	thiz.tableData = data.data;
		    }else{
		    	thiz.$message.error("查询异常");
		    }
		  }).catch(function (error) {
		  	loading.close();
		    console.log(error);
		    thiz.$message.error("系统异常，请与管理员联系!");
		  });
	},
	dateFormat(row,column){
		var str = row[column.property];
		if(str == null || str == ""){
			return "";
		}else{
			return this.getFullStandardDate(str);
		}
	},
    getMessage(row){
    	alert(row.productName);
    },
    getFullStandardDate(str){
    	var val = new Date(str)
    	var year = val.getFullYear();
        var month = val.getMonth() + 1;
        var day = val.getDate();
        var hour = val.getHours();
        var minute = val.getMinutes();
        var second = val.getSeconds();
        month = month < 10 ? "0"+month : month;
        day = day < 10 ? "0"+day : day;
        hour = hour < 10 ? "0"+hour : hour;
        minute = minute < 10 ? "0"+minute : minute;
        second = second < 10 ? "0"+second : second;
        return year+"-"+month+"-"+day+" "+hour+":"+minute+":"+second;
    },
    moneyFormat(val){
        val = val.toString().replace(/[^\d.-]/g,""); //清除"数字"和"."以外的字符
        let val1 = parseFloat(val).toFixed(2);  //保留两位小数
        let val2 = val1.toString();
        let arr = val2.split('.');
        let arr1 = arr[0].split('');
        let str3 = "";
        let arr2 = [];
        for(let i=arr1.length-1,j=0;i>=0;i--,j++) {
          str3 = '' + arr1[i] + str3;
          if(j%3==2) {
            arr2.unshift(str3)
            str3 = "";
          }else if(i==0) {
            arr2.unshift(str3)
          }
        }
        let str4 = arr2.join(',');
        let str5 = str4 + '.' + arr[1];
        return str5;
    }
  }
}
</script>

<style>
	.el-table{
	  	font-size: 12px;
	  	border-bottom: 1px solid #dcd8d8;
	  	color: black;
	}
	.el-table tr th{
	    border-top: 0px;
	  	border-left: 0px;
	  	border-right: 0px;
	}
	.el-table tr td{
	  	border-bottom: 1px solid #dcd8d8;
 	}
</style>
